import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer className="footer-wrapper footer-layout1">
                <div className="container">
                    <hr className='mb-5' />
                    <div className="row justify-content-between">
                        <div className="col-md-6 col-xl-4">
                            <div className="widget footer-widget">
                                <div className="th-widget-about">
                                    <div className="col-md-10 footer-logo about-logo">
                                        <img src="/assets_web/img/logo/delight_logo.jpg" alt="Delight" />
                                    </div>
                                    <p className="about-text">
                                        For the first time in Dhule City, Alhamdulillah, we bring you this
                                        life-changing offer. Be part of the
                                        HarmainFalahHajjUmrah Campaign
                                        and see your duwas come true,
                                        Insha'Allah
                                    </p>
                                    <div className="th-social">
                                        <Link
                                            target="_blank"
                                            to="https://www.facebook.com/p/Har-Fard-Hajj-Umrah-61566920006162/?rdid=iY0EpHmy40Lz5MDm&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Bandf6r17%2F">
                                            <i className="fab fa-facebook-f" />
                                        </Link>{" "}
                                        <Link
                                            target="_blank"
                                            to="https://x.com/i/flow/login?redirect_after_login=%2FHarFardHajUmrah">
                                            <i className="fab fa-twitter" />
                                        </Link>{" "}
                                        <Link
                                            target="_blank"
                                            to="linkedin.com/in/delight-my-trip-b56b98328">
                                            <i className="fab fa-linkedin-in" />
                                        </Link>{" "}
                                        <Link
                                            target="_blank"
                                            to="wa.me/918055118236">
                                            <i className="fab fa-whatsapp" />
                                        </Link>{" "}
                                        <Link
                                            target="_blank"
                                            to="https://www.instagram.com/hfhu.vision/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#">
                                            <i className="fab fa-instagram" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-6 col-xl-auto">
                            <div className="widget widget_nav_menu footer-widget">
                                <h3 className="widget_title">Quick Links</h3>
                                <div className="menu-all-pages-container">
                                    <ul className="menu">
                                        <li>
                                            <a href="index.html">Umrah Packages</a>
                                        </li>
                                        <li>
                                            <a href="about.html">Ramadan Packages</a>
                                        </li>
                                        <li>
                                            <a href="service.html">Hajj Packages</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Address</h3>
                                <div className="th-widget-contact">
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets_web/img/icon/phone.svg" alt="img" />
                                        </div>
                                        <div className="details d-flex align-items-center">
                                            <p>
                                                <a href="tel:+91 8055118236" className="info-box_link">
                                                    +91 8055118236
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets_web/img/icon/envelope.svg" alt="img" />
                                        </div>
                                        <div className="details d-flex align-items-center">
                                            <p>
                                                <a
                                                    href="mailto:hfhuvisionpvtltd@gmail.com"
                                                    className="info-box_link"
                                                >
                                                    hfhuvisionpvtltd@gmail.com
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-box_text">
                                        <div className="icon">
                                            <img src="/assets_web/img/icon/location-dot.svg" alt="img" />
                                        </div>
                                        <div className="details">
                                            <p>Shop No. 3, Beside ENERGYM, Firdous Nagar Dhule</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-auto">
                            <div className="widget footer-widget">
                                <h3 className="widget_title">Recent Gallery</h3>
                                <div className="sidebar-gallery">
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-01.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <Link
                                            target="_blank"
                                            to="/assets_web/img/gallery/footer-G-01.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </Link>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-02.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-02.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-03.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-03.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-04.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-04.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-05.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-05.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-06.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-06.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-07.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-07.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-08.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-08.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                    <div className="gallery-thumb">
                                        <img
                                            src="/assets_web/img/gallery/footer-G-09.jpg"
                                            alt="Gallery (Image)"
                                        />{" "}
                                        <a
                                            target="_blank"
                                            href="/assets_web/img/gallery/footer-G-09.jpg"
                                            className="gallery-btn"
                                        >
                                            <i className="fal fa-magnifying-glass-plus" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="copyright-wrap"
                    data-bg-src="/assets_web/img/bg/copyright_bg_1.jpg"
                >
                    <div className="container">
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-6">
                                <p className="copyright-text text-start">
                                    Developed by <Link to="https://www.webdekho.in/">WebDekho</Link>.
                                </p>
                            </div>
                            <div className="col-md-6 text-end d-none d-md-block">
                                <div className="footer-card">
                                    <span className="title">We Accept</span>{" "}
                                    <img src="/assets_web/img/shape/cards.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
